<template>
    <div class="flat-view" style="display: flex; flex-flow: column; height: 100%;">
        <ul class="nav nav-tabs container" style="flex: 0 1 auto;">
            <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                <a  class="nav-link" href="#" @click.prevent="load(tab.id)" :class="{ active: tab.active }">
                    {{tab.title}}
                </a>
            </li>
        </ul>
        <div class="container" style="width: 100%; overflow: auto; background-color: white;">
            <div v-if="!busy" class="container" style="">
                <table class="table table-hover table-bordered table-sm mt-3">
                    <tr>
                        <th v-for="col in cols" :key="col.itemType">{{col.displayType}} 
                            <i v-if="col.itemType == finishedColumn" class="fa fa-exclamation-circle" title="Actions Items created in the last 30 days that have been finished"></i>
                        </th>
                    </tr>
                    <tr v-for="row in rows" :key="row.userId">
                        <td v-for="col in cols" :key="col.itemType">
                            <span>{{data[row.userId][col.itemType]}}</span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            rows: [],
            cols: [],
            data: {},
            tab: null,
            tabs: [
                {
                    id: "css",
                    title: "CSS Team",
                    role: "iss",
                    active: false
                },
                {
                    id: "finance",
                    title: "Finance Team",
                    role: "finance",
                    active: false
                },
                {
                    id: "ops",
                    title: "Ops Team",
                    role: "ops",
                    active: false
                },
                {
                    id: "qa",
                    title: "QA Team",
                    role: "qa",
                    active: false
                }
            ],
            finishedColumn: "Finished (30 Days)", //must match string in endpoint
            userNameColumn: "Full-Name"
        }
    },
    computed: {
        ...amfx.map("session", "role:primaryRole")
    },
    methods: {
        ...amfx.map("actionItems", "search"),
        getRows(rawResults) {
            let rows =  _.chain(rawResults.map(r => ({userId: r.userId, columns: []}))).uniqBy('userId').value();
            rows.push(rows.splice(rows.findIndex(x => x.userId == null), 1)[0]);
            return rows;
        },
        getColumns(rawResults) {
            let columns = _.chain(rawResults.map(c => ({itemType: c.itemType, displayType: this.getDisplayType(c.itemType), isHyperlink: this.isHyperlink(c.itemType)})))
                .uniqBy('itemType').orderBy('itemType', 'asc').value();
            columns.push(columns.splice(columns.findIndex(c => c.itemType === this.finishedColumn), 1)[0]);
            columns.unshift({itemType: this.userNameColumn, displayType: this.getDisplayType(this.userNameColumn)});
            return columns;
        },
        getDisplayType(itemType) {
            return _.chain(itemType).replace('ewf', '').replace(/-/g, ' ').value();
        },
        isHyperlink(itemType) {
            let noHyperlinkColumns = [this.userNameColumn, this.finishedColumn]
            return !noHyperlinkColumns.includes(itemType);
        },
        buildTableData(rawResults, rows, cols) {
            let data = {};
            for (let row of rows) {
                data[row.userId] = {};
                let results = rawResults.filter(r => r.userId == row.userId);
                for (let col of cols) {
                    if (col.itemType !== this.userNameColumn) {
                        let aiType = results.find(r => r.itemType == col.itemType);
                        data[row.userId][col.itemType] = aiType == null ? 0 : aiType.aiCount;
                    }
                    else {
                        data[row.userId][this.userNameColumn] = results.find(r => r.userId == row.userId).fullName;
                    }
                }
            }
            return data;
        },
        async loadData(){
            let rawResults = await romeApi.get(`workflow/actionitem/team/stats?role=${this.tab.role}`);
            this.rows = this.getRows(rawResults);
            this.cols = this.getColumns(rawResults);
            this.data = this.buildTableData(rawResults, this.rows, this.cols);
        },
        async load(tabId) {
            this.selectTab(tabId);
            this.loadData();
        },
        async searchActionItems(userId, actionItemType) {
            if (userId === null) {
                this.search({role: this.tab.role, type: actionItemType });
            }
            else {
                this.search({assignedToId: userId, type: actionItemType });
            }
        },
        selectTab(tabId) {
            this.tabs.forEach(t => t.active = false);

            let tab;
            if (tabId) {
                tab = this.tabs.find(t => t.id === tabId);
            } else {
                tab = this.tabs.find(t => t.role === this.role);
            }

            if (!tab) {
                tab = this.tabs[0];
            }

            tab.active = true;
            this.tab = tab;
        },
    },
    created() {
        this.load();
    }
}
</script>


// WEBPACK FOOTER //
// src/workflow/TeamStats.vue